import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NotificationDisplayComponent } from './after-login/components/notification-display/notification-display.component';
import { TranslationService } from './services/translation.service';
@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgxSpinnerModule, NotificationDisplayComponent, TranslateModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {
    title = 'syncinns';
    public router: Router = inject(Router);
    public translationService: TranslationService = inject(TranslationService);
    public currentUrl: string = '';
    constructor() {
        this.router.events.subscribe((routes) => {
            if (routes instanceof NavigationEnd) {
                this.currentUrl = routes.url;
            }
        });
    }
}
